import getSession from "./getSession";
import dev, { isClient, isLocal } from "../utils/dev";
import { flattenObject } from "../utils/utils";
import * as fbAnalytics from "./trackers/facebook";
import * as gaAnalytics from "./trackers/ga";
import { B2B_BACKEND } from "../index";

const postSessionInfo = (message) => {
  console.log("[LOG-SESSION] Sending data...");
  const fetchLog = async (...p) => dev.console.log(...p) ?? {};

  return (!isLocal ? fetch : fetchLog)(new URL("sources", B2B_BACKEND), {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(message),
  });
};

const logSession = async () => {
  if (!isClient) throw Error("[Analytics] Not a client");

  const {
    id,
    url,
    hostname,
    cookie,
    getLocation,
    device,
    utm,
    campaignId,
    cinemapId,
    cinemapCampaign,
    cinemapContent,
    movieId,
    originalUtm,
  } = getSession();
  const location = await getLocation();

  const message = {
    location,
    id,
    url,
    hostname,
    cookie_id: cookie,
    referral_url: document.referrer,
    device,
    utm,
    original_utm: originalUtm,
    movie_id: movieId,
    cinemap_id: cinemapId,
    cinemap_campaign: cinemapCampaign,
    cinemap_content: cinemapContent,
    ga_id: await gaAnalytics
      .getTracker()
      .then((tracker) => tracker.get("clientId"))
      .catch(() => console.warn("[LOG-SESSION] Retrieve Client ID has failed")),
    microsite: { campaign_id: campaignId },
  };

  postSessionInfo(message).catch(console.error);

  fbAnalytics.track("logSession", {
    ...flattenObject(message),
  });
  fbAnalytics.page({
    cinemap_id: cinemapId === 0 || cinemapId ? cinemapId : "",
  });
};

export default logSession;
